import React from "react";

// AK 10/21/2024: Colors are currently hard coded to keep the look and feel consistent across the whole app.
interface ProgressBarProps {
  progress: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  return (
    <div
      className="progress my-3"
      style={{
        height: `20px`,
        backgroundColor: "hsl(210, 14%, 80%)",
        borderRadius: "5px",
        overflow: "hidden",
      }}
    >
      <div
        className="progress-bar"
        role="progressbar"
        aria-label="Upload progress"
        style={{
          width: `${progress}%`,
          backgroundColor: "hsl(216, 98%, 52%)",
          transition: "width 0.4s ease-in-out",
        }}
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        {progress}%
      </div>
    </div>
  );
};

export default ProgressBar;
